import { z } from "zod";

export const getAssignUserFormSchema = () => {
	return z.object({
		userId: z.number().nullish(),
	});
};

export type AssignUserFormModel = z.infer<
	ReturnType<typeof getAssignUserFormSchema>
>;
